import { isPickingListPdfEnabled } from '@/feature/picking-list-pdf.feature';
import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { analyticsEvents, analyticsModalIds, trackAnalyticsEvent } from '@/utils/analytics.utils';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetPickingListPdfListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);

    if (!isPickingListPdfEnabled(data)) {
        return null;
    }

    return (
        <ListViewItem
            title={translate('asset_picking_list_modal_header')}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.PICKING_LIST_PDF);
                trackAnalyticsEvent({
                    eventName: analyticsEvents.modalOpened,
                    custom: {
                        assetId,
                        id: analyticsModalIds.pickingList,
                    },
                });
                onClose?.();
            }}
        />
    );
};

export const AssetPickingListPdfAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }

    return <AssetPickingListPdfListItem {...props} />;
};
